import PopupMenu, {
    PopupMenuTarget,
} from "diagram-js/lib/features/popup-menu/PopupMenu";
import PopupMenuProvider, {
    PopupMenuEntries,
    PopupMenuEntriesProvider,
} from "diagram-js/lib/features/popup-menu/PopupMenuProvider";
import Translate from "diagram-js/lib/i18n/translate/translate";

const REPLACE_WITH_COLLAPSED = "replace-with-collapsed-subprocess";
const REPLACE_WITH_COLLAPSED_AD_HOC =
    "replace-with-collapsed-ad-hoc-subprocess";
const REPLACE_WITH_CALL_ACTIVITY = "replace-with-call-activity";

export default class StekzReplaceMenuProvider implements PopupMenuProvider {
    static $inject = ["popupMenu", "translate"];

    constructor(
        popupMenu: PopupMenu,
        private translate: typeof Translate
    ) {
        popupMenu.registerProvider("bpmn-replace", this);
    }

    getPopupMenuEntries(
        _: PopupMenuTarget
    ): PopupMenuEntriesProvider | PopupMenuEntries {
        return (entries) => {
            if (REPLACE_WITH_COLLAPSED in entries) {
                delete entries[REPLACE_WITH_COLLAPSED];
            }
            if (REPLACE_WITH_COLLAPSED_AD_HOC in entries) {
                delete entries[REPLACE_WITH_COLLAPSED_AD_HOC];
            }
            // Rename Call activity replace.
            if (REPLACE_WITH_CALL_ACTIVITY in entries) {
                entries[REPLACE_WITH_CALL_ACTIVITY].label = this.translate(
                    "Call activity (linked process)"
                );
            }
            return entries;
        };
    }
}
